module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_verified_frame-b2b1075aca2c34eaededf4ac790b3af0.png";